import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-side-container',
  templateUrl: './side-container.component.html',
  styleUrls: ['./side-container.component.scss']
})
export class SideContainerComponent implements OnInit {
  @Input() container_width: string;
  @Output() side_div_events = new EventEmitter();
  @Input() container_title = '';
  @Input() unique_id? = '';
  @Input() date_visible?:boolean=false;
  @Input() date?:Date=null;
  @Input() placement: 'left' | 'right' = 'right';
  @Input() z_index?:number = 9999;
  @Input() expand_collapse_feature?:boolean=false;
  @Input() container_class?:string="";

  container_minimized: boolean=false;
  container_closed: boolean=false;
 

  constructor(private _elementRef: ElementRef) {
  }

  ngOnInit() {

  }

  openContainer() {
    this.container_closed=false;
    this.container_minimized = false;
    $('#sideContainer' + this.unique_id).css('border', '0' );
    $('#sideContainer' + this.unique_id).css('z-index', this.z_index );
    $('#sideContainer' + this.unique_id).width(this.container_width);
    $('#sideContainer' + this.unique_id).css('border', '2px solid #294178');
    $('#sideContainer' + this.unique_id).scrollTop(0);
    this.container_placement();
  }  

  container_placement(){
    console.log(this.placement)
    const direction_literal = {
      right: () => {
        $('#sideContainer' + this.unique_id).css({ 'right': '0px', 'left': '' });
      },
      left: () => {
        $('#sideContainer' + this.unique_id).css({ 'right': '', 'left': '0px' });
      },
    } // future cases top bottom tbd.
    direction_literal[this.placement]();
  }

  closeContainer() {
    this.container_closed=true;
    this.container_minimized=false;
    this.side_div_events.emit({"type": "close"})
    $('#sideContainer' + this.unique_id).css('border', '0');
    $('#sideContainer' + this.unique_id).width('0');
    // $('#main').css('background-color', 'white');
  }

  expandContainer(){
    this.container_closed=false;
    this.container_minimized = false;
    $('#sideContainer' + this.unique_id).css('border', '0' );
    $('#sideContainer' + this.unique_id).css('z-index', this.z_index );
    $('#sideContainer' + this.unique_id).width(this.container_width);
    $('#sideContainer' + this.unique_id).css('border', '2px solid #294178');
    this.container_placement();
  }

  collapseContainer(){
    this.container_minimized=true;
    this.container_closed=false;
    $('#sideContainer'+this.unique_id).css('border','0');
    $('#sideContainer'+this.unique_id).width('0');
  }

}
